<script setup lang="ts">
import { IconPending, IconError, Fragment, IconSchedule, useRelativeDatePosition, useDatetimeString } from '#shared'
import { computed, toRef } from 'vue'
import type { Message } from '../model/message'

const { message, variant = 'regular' } = defineProps<{ message: Message; variant?: 'regular' | 'compact' }>()

const relativeScheduleDatePosition = useRelativeDatePosition(toRef(() => message.scheduledAt))
const isScheduled = computed(() => relativeScheduleDatePosition.value === 'future')

const scheduledDatetimeString = useDatetimeString(toRef(() => message.scheduledAt))
</script>

<template>
  <div :class="$style.statusWrap">
    <IconPending v-if="message.meta?.isSending" :class="$style.icon" />

    <Fragment v-else-if="message.meta?.isErrored">
      <IconError :class="$style.icon" />
      <span v-if="variant === 'regular'" :class="[$style.statusText, $style.statusTextError]">Failed to send</span>
    </Fragment>

    <Fragment v-else-if="isScheduled">
      <IconSchedule :class="$style.icon" />
      <span v-if="variant === 'regular'" :class="[$style.statusText, $style.statusTextScheduled]">
        Scheduled for {{ scheduledDatetimeString }}
      </span>
    </Fragment>
  </div>
</template>

<style lang="scss" module>
.statusWrap {
  display: flex;
  gap: 5px;
  transform: translateY(2px);
}

.icon {
  width: 15px;
  height: 15px;
}

.statusText {
  font-size: 14px;
}

.statusTextError {
  color: #f44336;
}
</style>
